<template>
  <div class="graphic-image-cover flex-center" @click="onChangeGraphic">
    <el-image class="graphic-image flex-center" :src="graphicSrc" alt="图形码">
      <div slot="placeholder" class="image-slot flex-center">
        加载中
        <span class="dot">...</span>
      </div>
      <div slot="error" class="image-slot flex-center">
        <i class="el-icon-document-delete"></i>
      </div>
    </el-image>
  </div>
</template>

<script>
import { getCaptchaApi } from '@/api/system.js'

export default {
  name: 'GraphicImage',

  data() {
    return {
      graphicSrc: '',
      graphicLoading: false
    }
  },
  created() {
    this.onChangeGraphic()
  },
  methods: {
    // 点击切换图形码
    onChangeGraphic() {
      getCaptchaApi()
        .then(res => {
          this.graphicSrc = 'data:image/png;base64,' + res.data.src
          this.$emit('getCaptchaToken', res.data.token)
        })
        .catch(err => {
          this.$message.error(err.data.message)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
// 定义图形码容器样式
.graphic-image-cover {
  width: 80px;
  overflow: hidden;
  margin-left: 1.25rem;
  border-radius: 0.25rem;

  // 定义图形码样式
  .graphic-image {
    width: 80px;
    height: 34px;
    border-radius: 0.25rem;
    border: 1px solid #eeee;
    background: #eee;
    cursor: pointer;

    // 定义图形码内部图片样式
    ::v-deep .el-image__inner {
      width: 100%;
      border-radius: 0.25rem !important;
    }

    .image-slot {
      height: 2rem;

      i {
        flex: 1;
      }
    }
  }
}
</style>
